import { GOOGLE_CALENDAR_URL } from './constants';

export const STATSIG_TIER_NAME = process.env.VITE_STATSIG_TIER_NAME;

export const STATSIG_CLIENT_ID = 'client-s9XLujJsKLSVLI9tzSq74hggPgyLnrQljdWEZ0jq0tY';

export const CAN_SEE_INSURANCE_METRICS_FG = 'cp-insurance-metrics';
export const CAN_SEE_RF_HOME_FG = 'cp-rf-home';
export const CAN_SEE_INTEGRATIONS_FG = 'cp-integrations';
export const CAN_DOWNLOAD_INSURANCE_PDF_FG = 'cp-download-insurance-pdf';
export const CAN_SEE_COLLABORATOR_INSURANCE_START_DATE_FG = 'cp-collaborator-insurance-start-date';
export const CAN_SEE_PAYROLL_REPORTS_FG = 'cp-payroll-reports';
export const CAN_SEE_DEPENDENTS_CARD_FG = 'cp-dependents-card';
export const CAN_SEE_DEPENDENTS_INSURANCE_START_COLUMN_FG = 'cp-dependents-insurance-start-column';
export const CAN_SEE_MANAGE_COLLABORATORS_DEPENDENTS_OPTION_FG = 'cp-add-dependents-option';
export const CAN_DOWNLOAD_NOVATION_FG = 'cp-download-novation';
export const CAN_SEE_REQUESTS_FG = 'cp-requests';
export const CAN_SEE_HEALTH_REPORTS_FG = 'cp-health-reports';
export const CAN_DOWNLOAD_HEALTH_REPORTS_FG = 'cp-download-health-reports';
export const CAN_SEE_METRICS_AND_REPORTS = 'cp-metrics-and-reports';
export const CAN_SEE_STORIES = 'cp-stories';
export const CAN_SEE_REWARDS = 'cp-rewards';
export const CAN_SEE_COLLABORATOR_BALANCE_TAB_FG = 'cp-collaborator-balance-tab';
export const CAN_SEE_HELP_US_IMPROVE_FG = 'cp-help-us-improve';

export const HELP_US_IMPROVE_SCHEDULE_CONFIG = {
  name: 'cp-help-us-improve-schedule',
  parameters: {
    url: {
      name: 'url',
      defaultValue: GOOGLE_CALENDAR_URL
    }
  }
};

export const BENEFITS_INFO_LAYER = {
  name: 'benefits_info',
  parameters: {
    dateRangeOption: {
      name: 'date_range_option',
      defaultValue: 'monthly'
    },
    chartPosition: {
      name: 'benefits_usage_chart_position',
      defaultValue: 'right'
    }
  }
};

export const IMPACT_MORE_INFO_BUTTON_EXPERIMENT = {
  name: 'bef_impact_more_info_position',
  parameters: {
    variant: {
      name: 'variant',
      defaultValue: false
    }
  }
};

export const BENEFITS_ADD_CUSTOM_BENEFIT_BUTTON_EXPERIMENT = {
  name: 'flx_add_custom_benefit_button',
  parameters: {
    variant: {
      name: 'Variant',
      defaultValue: 'A'
    }
  }
};
